// src/components/ui/dashboard/grades-chart.tsx
"use client"

import { useThemeStore } from "@/hooks/stores/themeStore"

interface GradeData {
  subject: string
  percentage: number
  color: string
}

interface GradesChartProps {
  grades?: GradeData[]
}

export function GradesChart({
  grades = [
    { subject: "Math", percentage: 85, color: "bg-blue-500" },
    { subject: "Science", percentage: 95, color: "bg-teal-500" },
    { subject: "Art", percentage: 70, color: "bg-purple-500" },
    { subject: "History", percentage: 80, color: "bg-amber-500" },
    { subject: "English", percentage: 90, color: "bg-red-500" },
  ],
}: GradesChartProps) {
  const currentTheme = useThemeStore((state) => state.getCurrentTheme());
  const maxPercentage = 100

  // Map grade colors to theme colors
  const themeColors = [
    currentTheme.colors.primary,
    currentTheme.colors.secondary,
    currentTheme.colors.accent,
    '#FFA500', // Amber fallback
    '#EF4444', // Red fallback
  ];

  return (
    <div
      className="p-6 rounded-2xl"
      style={{
        backgroundColor: 'var(--theme-card)',
        border: `1px solid ${currentTheme.colors.border}`
      }}
    >
      <h3
        className="text-xl font-bold mb-4"
        style={{ color: 'var(--theme-foreground)' }}
      >
        Grades
      </h3>
      <div className="flex justify-between items-end h-40 gap-2">
        {grades.map((grade, index) => (
          <div key={index} className="flex flex-col items-center flex-1">
            <div
              className="w-full rounded-t-lg transition-all duration-300"
              style={{
                backgroundColor: themeColors[index % themeColors.length],
                height: `${(grade.percentage / maxPercentage) * 100}%`,
                opacity: 0.8
              }}
            ></div>
            <p
              className="text-xs mt-2"
              style={{ color: 'var(--theme-foreground)', opacity: 0.7 }}
            >
              {grade.subject}
            </p>
            <p
              className="text-sm font-bold mt-1"
              style={{ color: themeColors[index % themeColors.length] }}
            >
              {grade.percentage}%
            </p>
          </div>
        ))}
      </div>
      <div className="flex justify-between mt-4">
        <p
          className="text-sm"
          style={{ color: 'var(--theme-foreground)', opacity: 0.7 }}
        >
          Average: {Math.round(grades.reduce((acc, g) => acc + g.percentage, 0) / grades.length)}%
        </p>
        <p
          className="text-sm font-medium"
          style={{ color: currentTheme.colors.primary }}
        >
          📈 Trending Up
        </p>
      </div>
    </div>
  )
}